export function ChecklistOptionsPlugin() {
  const tomSelect = this

  tomSelect.settings.hideSelected = false

  tomSelect.hook("after", "setup", () => {
    tomSelect.dropdown_content.setAttribute("aria-multiselectable", "true")
  })

  tomSelect.hook("instead", "onOptionSelect", (event, option) => {
    if (option.parentElement?.matches("[data-disabled]")) {
      return
    }

    const value = option.dataset.value

    if (value === undefined) {
      return
    }

    if (tomSelect.items.includes(value)) {
      tomSelect.removeItem(value)
    } else {
      tomSelect.addItem(value)
    }

    if (tomSelect.dropdown_content.contains(option)) {
      tomSelect.setActiveOption(option)
    }
  })

  tomSelect.hook("instead", "setActiveOption", (option, scroll = true) => {
    if (option === tomSelect.activeOption) {
      return
    }

    tomSelect.clearActiveOption()

    if (!option) {
      return
    }

    tomSelect.activeOption = option
    tomSelect.focus_node.setAttribute("aria-activedescendant", option.getAttribute("id"))
    option.classList.add("active")

    if (scroll) {
      tomSelect.scrollToOption(option)
    }
  })

  tomSelect.hook("instead", "clearActiveOption", () => {
    if (tomSelect.activeOption) {
      tomSelect.activeOption.classList.remove("active")
    }

    tomSelect.activeOption = null
    tomSelect.focus_node.removeAttribute("aria-activedescendant")
  })

  tomSelect.hook("after", "refreshOptions", () => {
    tomSelect.dropdown_content.querySelectorAll("[role='option']").forEach((option) => {
      setChecked(option, option.classList.contains("selected"))
    })
  })

  tomSelect.on("item_add", (value) => {
    updateOption(value, true)
  })

  tomSelect.on("item_remove", (value) => {
    updateOption(value, false)
  })

  function updateOption(value, checked) {
    const option = tomSelect.getOption(value)

    if (!option) {
      return
    }

    option.classList.toggle("selected", checked)
    setChecked(option, checked)
  }

  function setChecked(option, checked) {
    option.setAttribute("aria-selected", String(checked))
  }
}
